import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILevelSubject, ILevelSubjects, ISubject, ISubjects } from '../interfaces/subject';
import { ITeacherClassSubjects } from '../interfaces/class';

@Injectable({
  providedIn: 'root',
})
export class SubjectService {
  constructor(private httpClient: HttpClient) {}

  getSubjects(url: string, filters: any): Observable<ISubjects> {
    return this.httpClient.get<ISubjects>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<ISubjects>;
  }

  getLevelSubjects(url: string, filters: Record<string, string | number>): Observable<ILevelSubjects> {
    return this.httpClient.get<ILevelSubjects>(url, {
      headers: { accept: '*/*' },
      params: filters,
    });
  }

  getTeacherClassSubjects(url: string, filters: Record<string, string | number>): Observable<ITeacherClassSubjects> {
    return this.httpClient.get<ITeacherClassSubjects>(url, {
      headers: { accept: '*/*' },
      params: filters,
    });
  }

  getSubjectById(url: string): Observable<ISubject | ILevelSubject> {
    return this.httpClient.get<ISubject | ILevelSubject>(url, { headers: { accept: '*/*' } }) as Observable<ISubject | ILevelSubject>;
  }

  editSubject(url: string, subjectForm: any): Observable<ISubject | ILevelSubject> {
    return this.httpClient.patch<ISubject | ILevelSubject>(url, subjectForm, {
      headers: { accept: '*/*' },
    }) as Observable<ISubject | ILevelSubject>;
  }

  createSubject(url: string, subjectForm: any): Observable<any> {
    return this.httpClient.post<any>(url, subjectForm, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }
}
